module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'scheduler',
        'scheduler',
    ],

    config: {
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_trips': true,
            'resourceChanged.bosch_tripDriverVessels': true,
            'resourceChanged.bosch_schoolVacation': true,
        },
    }
}